export default async function buildUrl() {
  const queryParams = new URLSearchParams(window.location.search);
  const uri = queryParams.get('goto');
  const encodedUrl = encodeURIComponent(uri);
  return encodedUrl;
}
